import SiteSettings from 'src/siteSetting';
import { loadThemes } from 'src/theme_mui';

// Map the site setting field from lendsmart to our internal need.
// The decalarative approach using visualFieldsMapper could be used as well.

export const getTheme = () => {
    return loadThemes(SiteSettings);
}